import { useMutation, useQueryClient } from 'react-query';
import * as userApi from '../user.api';


export default function useDeleteAgent() {
  const queryClient = useQueryClient();
  const currentUser = queryClient.getQueryData(['user.currentUser']);

  return useMutation(
    (agentId) => userApi.deleteAgent({ agentId }),
    {
      onSuccess: async () => {
        // users (company users should be updated)
        queryClient.invalidateQueries(['users.companyUsers', currentUser?.company_id]);

        // background-tasks (agent's background tasks should be removed)
        queryClient.invalidateQueries('background-tasks');

        // Gmail (agent's Gmail integration should be removed)
        queryClient.invalidateQueries(['gmail.gmail-integrations', currentUser?.company_id]);
      },
    });
}